//Node Modules
import { useTranslation } from "react-i18next";
import { Link } from "react-router-dom";
import { useRecoilValueLoadable } from "recoil";

//BinaryForge Components
import { Loading, Note } from "../helpers";

//Atoms
import { userSummarySelector } from "../../atoms/dashboard";

//Other
import { nav } from "../../config/navigation";

const ROLES = ["OWNER", "TENANT", "INSTALLER"];

//Compact role breakdown - the doughnut said the same with more ink
const UserSummaryCard = () => {
	const { t } = useTranslation();
	const { state, contents } = useRecoilValueLoadable(userSummarySelector);

	if (state === "loading") return <Loading />;
	if (state === "hasError")
		return (
			<Note
				messageKey={`Error: ${contents.message ? contents.message : contents}`}
				icon="pi-exclamation-circle fontColour-error"
			/>
		);

	return (
		<div className="flexVert gapRow-xsmall">
			{ROLES.map((role) => (
				<div key={role} className="flex jContent-spaceBetween">
					<span>{t(`user.role.${role}`)}</span>
					<span className="fontWeight-bold">{contents.roleCounts.active[role] ?? 0}</span>
				</div>
			))}
			<div className="flex jContent-spaceBetween fontColour-light">
				<span>{t("dashboard.user.inactive")}</span>
				<span className="fontWeight-bold">{contents.total.inactive}</span>
			</div>
			<Link to={`${nav.user.base}/${nav.user.management}`} className="fontSize-small marginTop-small">
				{t("dashboard.user.manage")}
			</Link>
		</div>
	);
};

export default UserSummaryCard;
